//#region redux
import { incomingInvoiceSnoozed } from "store/actions/incomingInvoiceActions";
import { useDispatch } from "react-redux";
//#endregion
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { TranslationKeys } from "translations";
//#endregion
import useSnoozeAction from "components/common/useSnoozeAction";
import { LocalizationHelperInstance } from "utils/helpers";

function useIncomingInvoiceSnoozeAction(id: number | string, onActionSuccess: (id: number | string) => void) {
  const dispatch = useDispatch();

  const onSnoozeInvoiceSuccess = () => {
    dispatch(incomingInvoiceSnoozed(id as number));
    onActionSuccess(id);
  };

  const { snoozeAction } = useSnoozeAction(
    id,
    WintSuperkollAPIModel.TodoType.IncomingInvoice,
    onSnoozeInvoiceSuccess,
    LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Invoice)
  );

  return snoozeAction;
}

export default useIncomingInvoiceSnoozeAction;
